// utils/loadGoogleAnalytics.js
export const loadGoogleAnalytics = (trackingId) => {
  if (typeof window === 'undefined' || window.gtag) return

  // Google Tag Manager base script
  const script1 = document.createElement('script')
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
  script1.async = true
  document.head.appendChild(script1)

  // gtag config
  const script2 = document.createElement('script')
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${trackingId}');
  `
  document.head.appendChild(script2)
}
